module.exports = __webpack_public_path__ + "bbe5fc974667ca4f3387c4771573d9d2.pdf";